const listeners = new Set();

// Successful local customer writes only. This is not a messaging socket event
// and must not advance cursors, reorder chats, or change unread state.
export function publishCustomerTypeChanged(change) {
  listeners.forEach(listener => listener(change));
}

export function subscribeCustomerTypeChanged(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
